import { createFileRoute } from '@tanstack/react-router';

import { DeleteAccountRequest } from '#modules/user/features/auth/components/DeleteAccountRequest';
import { staticPageHead } from '#features/static-pages/utils/head';

const title = 'Delete your account | Teamplay.gg';
const description =
  'How to delete your Teamplay.gg account, including when you can no longer sign in.';

// Public on purpose: Google Play wants account deletion to be requestable without
// installing the app, and this URL goes into the Data safety form. Under _layout, not
// _authed — someone who cannot sign in is exactly who needs it.
export const Route = createFileRoute('/{-$locale}/_layout/delete-account')({
  component: DeleteAccountRequest,
  head: ({ params }) =>
    staticPageHead({
      title,
      description,
      pathname: '/delete-account',
      locale: params.locale,
    }),
});
